import { IWorkflowItemStep } from '../../../../common/sharedTypes';
import Api from '../../../../services/Api';
import { ApiResponse } from 'apisauce';
import { DriverReportQueueActionTypes } from '../types';
import {toast} from "react-toastify";

export const searchPaperReports = (url: string) => {
  return async (dispatch) => {
    try {
      await Api.get(url).then((response: ApiResponse<any>) => {
        dispatch(setPaperReports(response.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};
export const setPaperReports = (notifications: IWorkflowItemStep[]) => {
  return {
    type: DriverReportQueueActionTypes.SEARCH_REPORTS,
    value: notifications,
  };
};

export const searchReportData = (url: string) => {
  return async (dispatch) => {
    try {
      await Api.get(url).then((response: ApiResponse<any>) => {
        dispatch(setReportData(response.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};
export const setReportData = (notifications: IWorkflowItemStep[]) => {
  return {
    type: DriverReportQueueActionTypes.GET_REPORT_DATA,
    value: notifications,
  };
};

export const openReport = (workflowItemStep: IWorkflowItemStep) => {
  return async (dispatch) => {
    await dispatch(view(workflowItemStep));
    return Promise.resolve(workflowItemStep);
  };
};
export const view = (workflowItemStep: IWorkflowItemStep) => {
  return {
    type: DriverReportQueueActionTypes.OPEN_REPORT,
    value: workflowItemStep,
  };
};

export const assignAndOpen = (url, stepItemId, assignToId) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        workflowStepItemId: stepItemId,
        assignToUserId: assignToId,
      }).then((result: ApiResponse<any>) => {
        dispatch(reduceAssignAndOpen(result.data));
        if(result.data == null){
          toast.error('Report already assigned');
          return Promise.reject(result.data);
        }
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const reduceAssignAndOpen = (itemStep: IWorkflowItemStep) => {
  return {
    type: DriverReportQueueActionTypes.ASSIGN_AND_OPEN_REPORT,
    value: itemStep,
  };
};

export const unAssign = (url, stepItem) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        workflowStepItemId: stepItem.id,
      }).then((result: ApiResponse<any>) => {
        dispatch(reduceUnAssign(result.data));
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};
export const reduceUnAssign = (itemStep: IWorkflowItemStep) => {
  return {
    type: DriverReportQueueActionTypes.UNASSIGN,
    value: itemStep,
  };
};

export const completeDriverReport = (
  url: string,
  itemStep: IWorkflowItemStep,
  data: any,
  moveToNextWorkflow: boolean,
  assignNext: boolean
) => (dispatch) =>
  new Promise(function (resolve, reject) {
    try {
      Api.post(url, {
        workflowItemStepId: itemStep.id,
        data: JSON.stringify(data),
        moveToNextWorkflow: moveToNextWorkflow,
        assignNext: assignNext,
      }).then((result: ApiResponse<any>) => {
        if (result.ok && result.data) {
          dispatch(reduceComplete(result.data));
        }
        resolve(result);
      });
    } catch (ex) {
      console.log(ex);
      reject(ex);
    }
  });

export const reduceComplete = (nextItemStep: IWorkflowItemStep) => {
  return {
    type: DriverReportQueueActionTypes.COMPLETE_DATA_ENTRY,
    value: nextItemStep,
  };
};

export const saveDriverReport = (
  url: string,
  itemStep: IWorkflowItemStep,
  data: any
) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        workflowItemStepId: itemStep.id,
        data: JSON.stringify(data),
      }).then((result: ApiResponse<any>) => {
        if (result.data) {
          dispatch(reduceComplete(result.data));
        }
        return Promise.resolve();
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};
export const reduceSave = (updatedItemStep: IWorkflowItemStep) => {
  return {
    type:
      DriverReportQueueActionTypes.SAVE_DATA_TRANSCRIBE_VALIDATION,
    value: updatedItemStep,
  };
};
